import React from 'react';
import {Box} from '@mui/material';

interface PlanSubItemsProps {
  expanded: boolean;
  children: React.ReactNode | null;
}

export const PlanSubItems: React.FC<PlanSubItemsProps> = ({expanded, children}) => {
  if (!expanded || !children) return null;
  return (
    <Box className="subplans" mt={2}>
      {children}
    </Box>
  );
};
